import ReconnectingWebSocket from 'reconnecting-websocket'
import { apiHost } from './api'
import store from '../redux/store'
import * as jwtUtils from '../util/jwt_utils'
import { socketStatusChange, receiveSocketEvent } from '../redux/action_creators'

class SocketApi {
    constructor(apiHost) {
        this.apiHost = apiHost
        this.handleOpen = this.handleOpen.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleError = this.handleError.bind(this)
        this.handleMessage = this.handleMessage.bind(this)
        this.handleAuthenticationResponse = this.handleAuthenticationResponse.bind(this)
        this.disconnect = this.disconnect.bind(this)
        this.lastEventID = ''
    }

    initialize() {
        if (this.ws) return

        const wsURL = this.apiHost.replace("http","ws") + "/ws/"
        this.ws = new ReconnectingWebSocket(
            wsURL,
            [], // protocols, fine to leave blank
            {
                minReconnectionDelay: 500,
                // debug: true, // for more debug logging
            }
        )
        this.ws.addEventListener('open', this.handleOpen)
        this.ws.addEventListener('message', this.handleMessage)
        this.ws.addEventListener('close', this.handleClose)
        this.ws.addEventListener('error', this.handleERror)
    }

    handleOpen() {
        // on websocket open, init authentication handshake
        const token = jwtUtils.getToken() || jwtUtils.getToken('tmp-token')
        this.ws.send(JSON.stringify({action: "authenticate", message: token}))
    }

    handleClose() {
        store.dispatch(socketStatusChange('disconnect'))
    }

    handleError(error) {
        console.log('Websocket error: ', error) // eslint-disable-line no-console
    }

    handleMessage(message) {
        var messages = message.data.split('\n')
        for (var i = 0; i < messages.length; i++) {

            const { event, object, action, message: actionMessage } = JSON.parse(messages[i])

            // if message is an authentication response
            if (action === "authenticateResponse") {
                this.handleAuthenticationResponse(actionMessage)
                return
            }

            // ignore duplicate events
            if (event.id === this.lastEventID) {
                console.log('DUPLICATE EVENT ID: ', event.id, ' TYPE: ', object.data.type)    // eslint-disable-line
                return
            }

            this.lastEventID = event.id

            store.dispatch(receiveSocketEvent(event, object))
        }
    }

    handleAuthenticationResponse(message) {
        // if not authenticated, disconnect
        if (message !== "ok") {
            // close connection and stop reconnecting
            console.log('Websocket not authenticated, disconnecting') // eslint-disable-line no-console
            this.disconnect()
            return
        }

        store.dispatch(socketStatusChange('connect'))
        return
    }

    disconnect() {
        if (this.ws) {
            this.ws.close()
            this.ws.removeEventListener('open', this.handleOpen)
            this.ws.removeEventListener('message', this.handleMessage)
            this.ws.removeEventListener('close', this.handleClose)
            this.ws.removeEventListener('error', this.handleERror)
            this.ws = null // set ws back to null so initialize will re-init
        }
    }
}

const socket = new SocketApi(apiHost)

// Old ping stuff in case needed to reimplement

// let pinger
// let lastPongTs = 0

// socket.addHandler('connect', () => {
//     const token = jwtUtils.getToken() || jwtUtils.getToken('tmp-token')
//     socket.emit('authenticate', token)
//     store.dispatch(socketStatusChange('connect'))
//     if (pinger) {
//         pinger = clearInterval(pinger)
//     }
//     pinger = setInterval( () => {
//         socket.emit('PING', 'PING')
//     }, 30000)
// })

// socket.addHandler('disconnect', () => {
//     store.dispatch(socketStatusChange('disconnect'))
//     clearInterval(pinger)
// })

// socket.addHandler('PONG', () => {
//     const now = new Date().getTime()
//     if (lastPongTs === 0) {
//         console.log("server acknowledged pong") // eslint-disable-line no-console
//         lastPongTs = now
//         return
//     }
//     const elapsed = Math.round((now - lastPongTs) / 1000)
//     console.log("server acknowledged pong", elapsed, "seconds ago") // eslint-disable-line no-console
// })

export default socket


// WEBPACK FOOTER //
// ./src/api/socket_client.js